<template>
    <div>
        <!-- Mensagem de Sucesso -->
        <div v-if="msg_alterar_senha">
            <v-alert type="success">
                {{ msg_alterar_senha }}

                <v-btn 
                  class="rounded-lg"
                  color="botao_1"
                  dark
                  @click="fazer_login()"
                >Fazer login</v-btn>
            </v-alert>
        </div>
        
        <div v-if="msg_alterar_senha===''">
            <span>
                <v-icon>mdi-information</v-icon>
                Insira sua nova senha
            </span>

            <v-form ref="form_alterar_senha" class="mt-5">
                <v-text-field
                label="Senha"
                v-model.trim="form.senha"
                :rules="[rules.obrigatorio, rules.min_8]"
                prepend-icon="mdi-lock"
                color="primary"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                :counter="8"
                :maxlength="8"
                clear-icon="mdi-close-circle"
                clearable
                ></v-text-field>

                <v-text-field
                label="Repita a Senha"
                v-model.trim="form.senha2"
                :rules="[rules.obrigatorio, rules.min_8,
                        () => form.senha == form.senha2 || 'As senhas devem ser iguais']"
                prepend-icon="mdi-lock"
                color="primary"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                :counter="8"
                :maxlength="8"
                clear-icon="mdi-close-circle"
                clearable
                ></v-text-field>
            </v-form>

            <div class="text-center mt-3 mb-3">
                <v-btn 
                class="rounded-lg mr-2"
                color="botao_2"
                text
                @click="cancelar()"
                >Cancelar</v-btn>

                <v-btn
                class="rounded-lg"
                color="botao_1"
                dark
                @click="alterar_senha(form)"
                >Alterar senha</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
import { mapMutations } from "vuex";

export default {
    name: "NovaSenha",

    props: {
        email: String,
    },

    data: () => ({
        msg_alterar_senha: "",
        show: false,
        rules: {
            obrigatorio: (v) => !!v || "Este campo é obrigatório",
            min_8: (v) => v.length >= 8 || "Mínimo 8 caracteres",
            min_3: (v) => v.length >= 3 || "Mínimo 3 caracteres",
        },
        form: {
            senha: "",
            senha2: "",
        },
    }),

    methods: {
        ...mapMutations(["CarregandoMutation"]),

        alterar_senha(form) {
            if (this.$refs.form_alterar_senha.validate()) {
                this.CarregandoMutation();
                form.email=this.email;

                api.post('perfil/esqueci-minha-senha/', form)
                .then((response) => {
                    if (response.data.status == 'ok') {
                        this.msg_alterar_senha = response.data.msg;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.CarregandoMutation();
                });
            }
        },

        cancelar() {
            this.$emit("cancelar");
        },

        fazer_login() {
            this.$emit("fazer-login");
        },
    }
}
</script>
